import axios from 'axios';

import queryString from '@/utils/queryString';
import { headers, salesServiceUrl } from '../../config';

export function getCustomer(id) {
    return axios.get(`${salesServiceUrl}/customers/${id}`, { headers: headers() });
}

export function getCustomers(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/customers?${query}`, { headers: headers() });
}

export function searchCustomers(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/customers-search?${query}`, { headers: headers() });
}

export function createCustomerReceivableAccount({customerId, form, dpk}) {
    return axios.post(`${salesServiceUrl}/customers/${customerId}/accounts`, form, { headers: {...headers(), Dpk: dpk} });
}

export function getCustomerReceivableAccount({customerId}) {
    return axios.get(`${salesServiceUrl}/customers/${customerId}/accounts`, { headers: headers() });
}